var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import Tooltip from 'components/Tooltip.vue';
import { ALLOWED_RELATED_BUSINESS_RELATIONS, } from '@/interfaces/company.interfaces';
let RelatedBusinessesCard = class RelatedBusinessesCard extends Vue {
    get isCompany() {
        return this.business.iconType === 'cnpj' && !!this.business.cnpj;
    }
    get displayRelation() {
        if (!this.business.relation)
            return '';
        const matched = ALLOWED_RELATED_BUSINESS_RELATIONS.some(r => this.business.relation === r || this.business.relation.startsWith(r));
        return matched ? this.business.relation : '';
    }
    reCenter() {
        if (this.isCompany) {
            const cnpjRaw = this.business.cnpj.replace(/[^\d]+/g, '');
            const sId = this.searchId || 's';
            window.open(`/search/${sId}/${cnpjRaw}`, '_blank');
            this.$emit('re-center', this.business.cnpj);
        }
    }
    get formattedWebsite() {
        if (!this.business.website)
            return '#';
        return this.business.website.startsWith('http')
            ? this.business.website
            : `https://${this.business.website}`;
    }
};
__decorate([
    Prop({ required: true, type: Object })
], RelatedBusinessesCard.prototype, "business", void 0);
__decorate([
    Prop({ type: String, default: '' })
], RelatedBusinessesCard.prototype, "searchId", void 0);
RelatedBusinessesCard = __decorate([
    Component({
        components: {
            Tooltip,
        },
    })
], RelatedBusinessesCard);
export default RelatedBusinessesCard;
